import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, memo } from "react";
import Grid from "@mui/material/Grid";

import requests from "../axios/Requests";
import { getComments } from "../../servicesRedux/ConferenceService";
import { GetCommentsAction } from "../../redux/action/CommentsAction";
import VideoSkeleton from "../../components/video/VideoSkeleton";
import LinkedVideoSkeleton from "../../components/linkedVideo/LinkedVideoSkeleton";

import DescriptionsSmallScreen from "../../components/descriptions/DescriptionsSmallScreen";
import LinkedVideoMobile from "../../components/linkedVideo/LinkedVideoMobile";
import Video from "../../components/video/Video";
import VideoBlocked from "../../components/video/VideoBlocked";
import VideoThumbnail from "../../components/video/VideoThumbnail";
import UnauthorizedConferenceModal from "./UnauthorizedConferenceModal";
import "../../theme/conferences/Conferences.scss";

const SmallScreenConferencePage = memo(({
    conference,
    setVideoHasLoaded,
    videoHasLoaded,
    id,
    isLoading,
    setIsLoading,
    userID,
    transcriptList,
    translation,
    triggerGetConferenceApi,
    setLinkedVideoHasLoaded,
    isSavedContent,
    like,
    linkedVideoHasLoaded,
    triggerLoader,
    point,
    likeCount,
    following,
    handleDownload,
    isDownloaded
}) => {
    const dispatch = useDispatch();
    const commentsLimit = 10;
    const [commentsPage] = useState(1);
    const { comments } = useSelector(state => state.commentsReducer);
    const [modalOpen, setModalOpen] = useState(false);

    const handleOpen = (e) => {
        if(conference?.isAuthenticated) return;
        e.stopPropagation(); // Stop the event from propagating further
        setModalOpen(true);
    };
    const handleClose = () => setModalOpen(false);


    useEffect(() => {
        if (conference.isAuthenticated)
            getComments(requests.GetComments, id, commentsPage, commentsLimit).then(item => dispatch(GetCommentsAction(item)));
    }, []);

    return (
        <div className="conferences">
            <UnauthorizedConferenceModal
                open={modalOpen}
                handleClose={handleClose}
                severity={"error"}
                translation={translation}/>
            <Grid container className={`conferences--styling conferences--styling--extended-sm ${modalOpen ? 'blur' : ''}`} sx={{ display: "flex" }}>
                <Grid item xs={12} className="conferences__video">
                    {conference.conference && (
                        <>
                            {conference?.conference?.isExternalContent ?
                                <VideoThumbnail
                                    thumbnailURL={conference.conference.thumbnailURL}
                                    setVideoHasLoaded={setVideoHasLoaded}
                                    externalContentLink={conference?.conference?.externalContentLink}

                                />
                                :
                                (!conference?.isContentAllowed?.isContentAllowed ?
                                    <VideoBlocked
                                        setVideoHasLoaded={setVideoHasLoaded}
                                        calledComponent={"Conferences"}
                                        isContentAllowed={conference?.isContentAllowed}
                                    />
                                    :
                                    <Video
                                        setVideoHasLoaded={setVideoHasLoaded}
                                        props={conference.conference}
                                        calledComponent={"Conferences"}
                                    />
                                )
                            }
                        </>
                    )}
                    {!videoHasLoaded && <VideoSkeleton className="video__skeleton" />}
                    <DescriptionsSmallScreen
                        id={id}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        tags={conference?.tag}
                        viewCount={conference?.viewCount}
                        contributor={conference?.contributors}
                        speaker={conference?.speaker}
                        infoConference={conference?.infoConference}
                        userID={userID}
                        transcriptList={transcriptList}
                        likes={conference?.review}
                        thumbnailURL={conference?.conference?.thumbnailURL}
                        translation={translation}
                        channel={conference?.channel}
                        contentId={conference?.contentId}
                        isSaved={conference?.isSaved || isSavedContent}
                        isliked={conference?.isliked || like}
                        triggerGetConferenceApi={triggerGetConferenceApi}
                        chapters={conference?.contentBookmarks}
                        staticimg={conference?.conference?.thumbnailURL}
                        isAuthenticated={conference?.isAuthenticated}
                        triggerLoader={triggerLoader}
                        highlights={conference?.contentHighlight}
                        point={point}
                        comments={comments}
                        likeCount={likeCount}
                        following={following}
                        isContentExternalLink={conference?.conference?.isExternalContent ?? false}
                        externalContentLink={conference?.conference?.externalContentLink}
                        handleDownload={handleDownload}
                        isDownloaded={isDownloaded}
                    />
                    <Grid
                        item xs={12}
                        className="sideBarRight__global"
                        onClick={handleOpen}
                    >
                        {!linkedVideoHasLoaded && <LinkedVideoSkeleton />}
                        {conference.contentId && (
                            <LinkedVideoMobile
                                contentId={conference?.contentId}
                                translation={translation}
                                setLinkedVideoHasLoaded={setLinkedVideoHasLoaded}
                                isAuthenticated={conference?.isAuthenticated}
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
});


export default SmallScreenConferencePage;